import { h, render, Component } from 'preact';
import { Wizard } from '../wizard';

export class InputPhoneNumber extends Component {

  constructor(props) {
    super(props);

    this.state = {
      focuskey: ''
    }
  }

  updatePhoneNumber = e => {
    this.props.updateWizard({ phoneNumber: e.target.value });
  };

  updateExtension = e => {
    this.props.updateWizard({ extension: e.target.value });
  };

  focus = e => {
    if(e.type == 'blur') {
      this.setState((prevState, props) => ({
        focuskey: ''
      }));
    } else {
      this.setState((prevState, props) => ({
        focuskey: e.target.getAttribute("id")
      }));
    }
  }

  // submitPhone = e => {
  //   var me = this;

  //   fetch(
  //     "/api/v1/enroll/phone",
  //     {
  //       method:"POST",
  //       body:JSON.stringify({
  //         "number": me.props.phoneNumber,
  //         "extension": me.props.extension,
  //         "type": me.props.deviceType,
  //         "platform": me.props.deviceOS}),
  //       headers:{"Content-Type":"application/json"}
  //     }
  //   ).then( resp => {
  //     return resp.json();
  //   }).then( data => {
  //     console.log('api/v1/phones', data);
  //     this.props.next();
  //   });
  // }

  render(props, state) {
		return (
      <Wizard
        title="Enter your phone number"
        prev={{callback: props.prev}}
        next={{callback: props.next, disabled: props.phoneNumber.length < 10}} >
        <div style="text-align:center">
          <div class={"floating-placeholder" + (state.focuskey == 'phoneNumber'?' float':'') + (props.phoneNumber != ''?' hidden':'')}>
            <input type="tel" class="large" id="phoneNumber" maxlength="10" value={props.phoneNumber}
              onBlur={this.focus}
              onFocus={this.focus}
              onInput={this.updatePhoneNumber}/>
            <label for="phoneNumber">Phone Number</label>
          </div>
        </div>
        { props.deviceType == 'landline' &&
        <div style="text-align:center">
          <div class={"floating-placeholder" + (state.focuskey == 'extension'?' float':'') + (props.extension != ''?' hidden':'')}>
            <input type="tel" id="extension" maxlength="10" value={props.extension}
              onBlur={this.focus}
              onFocus={this.focus}
              onInput={this.updateExtension}/>
            <label for="extension">Extension</label>
          </div>
        </div>
        }
      </Wizard>
		)
  }
}
